import styled from "styled-components";

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: black;
  opacity: 0.15;
`;

export default Divider;
